import { useCallback } from 'react';
import type { PaginationInput } from '../query-keys';

type P = {
  offset?: number;
  pagination?: PaginationInput;
};

export const useOffsetInfinitePagination = () =>
  useCallback(
    ({ offset, pagination }: P): Extract<PaginationInput, { type: 'offset' }> => ({
      offset,
      pageSize: pagination?.pageSize,
      type: 'offset',
    }),
    [],
  );
